(function($, d, w) {

	w.ZP_EVENT_ACCORDION_TOGGLE = "zp.accordion.toggle";

	$(w).on(w.ZP_READY, onInit);

	function onInit()  {
		var $elements = $('.zp_accordion_element');
		if($elements.length > 0) {
			var $headers = $elements.find("> .collapse-header");
			$headers.on('click', toggleCollapse);
		}

		var $accordions = $('.zp_accordion.accordion');
		if($accordions.length > 0) {
			$accordions.each(function(index, element) {
				var $ele = $(element);
				var $tabs = $ele.find(".zp_accordion_element > .collapse-header");
				$tabs.attr("data-parent", "#" + $ele.attr("id"));
			});
		}
	}

	function toggleCollapse() {
		var $ele = $(this);
		var $container = $ele.closest(".zp_accordion_element");
		if($container.hasClass("open")) {
			$container.removeClass("open");
			$(w).trigger(w.ZP_EVENT_ACCORDION_TOGGLE, [{element:$container, status:"close"}]);
		} else {
			$container.addClass("open");
			$(w).trigger(w.ZP_EVENT_ACCORDION_TOGGLE, [{element:$container, status:"open"}]);
		}
		setTimeout(function() {
			$(w).resize();
		}, 500);
	}

})(jQuery, document, window);